module.exports = __webpack_public_path__ + "img/2_david_s.3a334f85.png";